module.exports = __webpack_public_path__ + "img/image61.53017994.jpg";